<script setup lang="ts">
import InfoIcon from './icons/InfoIcon.vue';
import InformationModal from './InformationModal.vue';

import { ref } from 'vue';

const infoIsActive = ref<boolean>(false);
</script>

<template>
  <InformationModal v-if="infoIsActive" @close="infoIsActive = false" />
  <div v-else class="bg-onboard-background h-full overflow-hidden text-onboard-foreground font-sans">
    <InfoIcon class="absolute right-4 bottom-4" @click="infoIsActive = true"/>
    <div class="m-auto h-full flex justify-center max-w-2xl">
      <router-view v-slot="{ Component }">
        <Transition name="fade" mode="out-in" appear>
          <component :is="Component" />
        </Transition>
      </router-view>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
